import { ValidationException } from "./validation-exception";

export class StateValidationException extends ValidationException {
    constructor(expectedState: string, record: any) {
        super(StateValidationException.createMessage(expectedState, record));
    }

    private static createMessage(expectedState: string, record: any): string {
        return `The record is not in the expected state. Expected state: ${JSON.stringify(expectedState)}. Record: ${JSON.stringify(record)}`;
    }
}